/**
 * Bitmart Exchange Metadata
 */

import { BITMART_WS_CHANNELS, BITMART_WS_TOPOLOGY } from './ws';

import type { ExchangeId, ExchangeMetadata } from '../../lib/types';

export const BITMART_METADATA: ExchangeMetadata = {
  id: 'bitmart' as ExchangeId,
  restDocs: ['https://developer-pro.bitmart.com/en/spot/#public-market-data'],
  wsDocs: ['https://developer-pro.bitmart.com/en/spot/#websocket-market-data'],
  wsTopology: BITMART_WS_TOPOLOGY,
  wsChannels: BITMART_WS_CHANNELS,
  notes: [
    'Symbol format: BASE_QUOTE (e.g., BTC_USDT)',
    'Binary frames are zlib raw-compressed.',
    'Send ping every 10-20s to keep connection alive.',
  ],
};
